<ng-container>
  <div>
    <button type="button"
      routerLink="/myaccount/manage-account-signatures"
      class="btn-secondary float-end">
      View All Signatures
    </button>
    @if (isReadDataFromSassEnabled) {
      <button id="view-certificate-button" type="button"
        routerLink="/myaccount/manage-account-certificates"
        class="btn-secondary float-end">
        View Certificate
      </button>
    }
    <h2>Commissions and Signatures</h2>
    <p class="mt-3">Different states will have varying requirements for commissions and signatures types. Select a state to continue.</p>
    <div id="your-states-text">
      <h2>Your Available States</h2>
      <p>Select the state you want to view or add a new state to your account.</p>
    </div>
    <div class="commissions">
      @for (activeCommission of activeCommissions; track activeCommission) {
        <mat-card (click)="editCommission(activeCommission.stateCode)">
          <mat-card-content>
            <div>
              <img [src]="getStateImage(activeCommission.stateCode)" alt="State Logo">
            </div>
            <div>
              <h6>{{ getStateByStateCode(activeCommission.stateCode) }}</h6>
            </div>
            <div>
              @if (needsAttention(activeCommission)) {
                <span
                  class="needs-attention"
                  [matTooltip]="getValidationMessages(activeCommission.statusCodeValidationFailures)"
                  matTooltipPosition="below"
                  >
                  <i class="fa-solid fa-triangle-exclamation"></i>
                  Needs Attention
                </span>
              } @else {
                <p>Ready</p>
              }
            </div>
          </mat-card-content>
        </mat-card>
      }
      @for (draftCommission of draftCommissions; track draftCommission) {
        <mat-card (click)="editCommission(draftCommission.stateCode)">
          <mat-card-content>
            <div>
              <img [src]="getStateImage(draftCommission.stateCode)" alt="State Logo">
            </div>
            <div>
              <h6>{{ getStateByStateCode(draftCommission.stateCode) }}</h6>
            </div>
            <span class="needs-attention">
              <i class="fa-solid fa-triangle-exclamation"></i>
              Needs Attention
            </span>
          </mat-card-content>
        </mat-card>
      }
      @if (!addingNewState) {
        <mat-card (click)="addNewState()">
          <mat-card-content>
            <h6>+</h6>
            <h6>Add New State</h6>
          </mat-card-content>
        </mat-card>
      }
      @if (addingNewState) {
        <mat-card>
          <mat-card-content>
            <h6>Available States</h6>
            <mat-form-field appearance="fill" class="clrsgn-form-field">
              <mat-label class="clrsgn-label">States</mat-label>
              <mat-select (selectionChange)="editCommission($event.value)">
                @for (state of availableCommissionStates; track state) {
                  <mat-option
                    [value]="state.code"
                    >
                    {{ state.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</ng-container>
